'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true,
});
exports.default = void 0;
var _react = _interopRequireDefault(require('react'));
var _base = require('@atlaskit/icon/base');
function _interopRequireDefault(e) {
	return e && e.__esModule ? e : { default: e };
}
const GoogleForm16Icon = (props) =>
	/*#__PURE__*/ _react.default.createElement(
		_base.Icon,
		Object.assign(
			{
				dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`,
			},
			props,
			{
				size: 'small',
			},
		),
	);
GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var _default = (exports.default = GoogleForm16Icon);
